;(() => {
  const ROOT_SELECTOR = '[data-combined-listing-root][data-combined-listing="true"]'
  let activeController = null

  function getRoot(target) {
    return target.closest(ROOT_SELECTOR)
  }

  function getSectionElement(root) {
    return root ? root.closest('.shopify-section[id^="shopify-section-"]') : null
  }

  function getSectionId(sectionEl) {
    return sectionEl ? sectionEl.id.replace(/^shopify-section-/, '') : ''
  }

  function getCurrentSelection(root, clickedItem) {
    const optionValueIds = []
    let originalRequestUrl = clickedItem?.dataset.productUrl
    let requestUrl = root.dataset.productUrl || window.location.pathname
    const groups = root.querySelectorAll('.swatches-select[data-id]')

    groups.forEach((group) => {
      let selected = group.querySelector('.is-selected, .is-selected-nt')
      if (clickedItem && group === clickedItem.closest('.swatches-select')) {
        selected = clickedItem
      }

      if (!selected) return

      const optionValueId = selected.dataset.optionValueId
      if (optionValueId) {
        optionValueIds.push(optionValueId)
      }

      if (selected.dataset.productUrl) {
        requestUrl = selected.dataset.productUrl
      }
    })

    return {
      optionValueIds,
      requestUrl: originalRequestUrl || requestUrl || window.location.pathname,
    }
  }

  function getSelectValue(select) {
    return select.options[select.selectedIndex] || select.selectedOptions?.[0] || null
  }

  function getCurrentSelectionFromVariantPicker(root, changedInput) {
    const optionValueIds = []
    const picker = root?.querySelector('variant-selects')

    if (!picker) {
      return { optionValueIds, requestUrl: root?.dataset.productUrl || window.location.pathname }
    }

    let originalRequestUrl =
      changedInput?.dataset?.productUrl || root.dataset.productUrl || window.location.pathname
    const fields = picker.querySelectorAll('fieldset, .product-form__input--dropdown')

    fields.forEach((field) => {
      let selected = null

      if (field.matches('fieldset')) {
        selected = field.querySelector('input[data-option-value-id]:checked')
      } else {
        const select = field.querySelector('select')
        selected = select ? getSelectValue(select) : null
      }

      if (changedInput) {
        if (changedInput.matches('select') && field.contains(changedInput)) {
          selected = getSelectValue(changedInput)
        } else if (field.contains(changedInput)) {
          selected = changedInput
        }
      }

      if (!selected) return

      const optionValueId = selected.dataset.optionValueId
      if (optionValueId) {
        optionValueIds.push(optionValueId)
      }

      if (selected.dataset.productUrl) {
        // originalRequestUrl = selected.dataset.productUrl;
      }
    })

    return {
      optionValueIds,
      requestUrl: originalRequestUrl || root.dataset.productUrl || window.location.pathname,
    }
  }

  function buildPageUrl(sectionEl, optionValueIds) {
    const nextRoot = sectionEl.querySelector(ROOT_SELECTOR)
    const nextProductUrl = nextRoot?.dataset.productUrl || window.location.pathname
    const nextUrl = new URL(nextProductUrl, window.location.origin)
    const variantInput =
      sectionEl.querySelector('#product-select_ppr option[selected]') ||
      sectionEl.querySelector('#cart-form_ppr input[name="id"]')

    if (variantInput?.value) {
      nextUrl.searchParams.set('variant', variantInput.value)
    }

    if (optionValueIds && Array.isArray(optionValueIds) && optionValueIds.length > 0) {
      nextUrl.searchParams.set('option_values', optionValueIds.join(','))
    }

    return nextUrl.toString()
  }

  function runScripts(container) {
    container.querySelectorAll('script').forEach((script) => {
      if (script.type && script.type !== 'text/javascript' && script.type !== 'module') return
      if (
        script.src &&
        Array.from(document.querySelectorAll(`script[src="${script.src}"]`)).some(
          (existingScript) => existingScript !== script,
        )
      ) {
        return
      }

      const newScript = document.createElement('script')
      Array.from(script.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value)
      })
      newScript.textContent = script.textContent
      script.parentNode.replaceChild(newScript, script)
    })
  }

  function bindLazyInclude(el, eventName, handler) {
    if (!el || el.dataset.combinedListingBound === 'true') return
    el.dataset.combinedListingBound = 'true'
    el.addEventListener(eventName, handler, { once: true })
    el.classList.add('lazyloadt4s')
  }

  function initLazyContent(sectionEl) {
    sectionEl.querySelectorAll('[data-js-callback] .lazypreloadt4s.nt_pre_img').forEach((el) => {
      bindLazyInclude(el, 'lazyincludeloaded', (event) => {
        if (!event.detail?.content) return
        const html = event.detail.content.split('<!--split-->')[1] || event.detail.content
        event.detail.content = html
      })
    })

    sectionEl.querySelectorAll('[data-js-callback] .nt_pr_js').forEach((el) => {
      bindLazyInclude(el, 'lazyincludeloaded', (event) => {
        if (!event.detail?.content) return
        const html = event.detail.content.split('<!--split-->')[1] || event.detail.content
        event.detail.content = html
      })

      el.addEventListener(
        'lazyincluded',
        (event) => {
          const prId = event.currentTarget.dataset.id
          if (!window.geckoShopify) return
          window.geckoShopify.NtproductPage(prId)
          window.geckoShopify.initModelViewerLibraries(prId)
          window.geckoShopify.initShopifyXrLaunch(prId)
          document
            .querySelectorAll('.nt_mfp_360')
            .forEach((item) => item.classList.add('sh_ani_css'))
        },
        { once: true },
      )
    })

    if (window.lazySizes?.loader?.checkElems) {
      window.lazySizes.loader.checkElems()
    }
  }

  function initSection(sectionEl) {
    runScripts(sectionEl)
    initLazyContent(sectionEl)

    if (window.geckoShopify?.ProductSection) {
      window.geckoShopify.ProductSection('_ppr')
    }

    window.geckoShopify?.initFlickityt4s?.()

    window.geckoShopify?.clickProduct?.()

    if (window.geckoShopify?.review) {
      window.geckoShopify.review()
    }
  }

  async function renderCombinedSection(root, clickedItem) {
    const sectionEl = getSectionElement(root)
    const sectionId = getSectionId(sectionEl)
    if (!sectionEl || !sectionId) return

    let pathname = window.location.pathname
    const { optionValueIds, requestUrl } = getCurrentSelection(root, clickedItem)

    if (optionValueIds.length === 0) return

    const request = new URL(requestUrl, window.location.origin)
    request.searchParams.set('section_id', sectionId)
    request.searchParams.set('option_values', optionValueIds.join(','))

    const nextPathname = new URL(request.toString()).pathname
    const shouldRetainElements = nextPathname === pathname

    if (activeController) {
      activeController.abort()
    }

    activeController = new AbortController()
    root.classList.add('combined-listing--loading')

    try {
      const response = await fetch(request.toString(), {
        signal: activeController.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })

      if (!response.ok) {
        throw new Error(`Combined listing render failed: ${response.status}`)
      }

      const nextHtml = await response.text()

      sectionEl.setAttribute('data-disable-transitions', 'true')
      if (!shouldRetainElements) {
        sectionEl.innerHTML = nextHtml
        initSection(sectionEl)
      } else {
        const nextDom = new DOMParser().parseFromString(nextHtml, 'text/html')
        const replaced = ['#shopify-section-pr_summary']
        replaced.forEach((selector) => {
          const el = sectionEl.querySelector(selector)
          const nextEl = nextDom.querySelector(selector)
          if (el && nextEl) {
            el.innerHTML = nextEl.innerHTML
          }
        })

        runScripts(sectionEl)
        initLazyContent(sectionEl)
      }

      setTimeout(() => sectionEl.removeAttribute('data-disable-transitions'), 100)

      const nextUrl = buildPageUrl(sectionEl)
      window.history.pushState({ path: nextUrl }, '', nextUrl)
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error(error)
      }
    } finally {
      const nextRoot = sectionEl.querySelector(ROOT_SELECTOR)
      ;(nextRoot || root).classList.remove('combined-listing--loading')
      activeController = null
    }
  }

  async function renderCombinedSectionFromVariantPicker(root, changedInput) {
    const sectionEl = getSectionElement(root)
    const sectionId = getSectionId(sectionEl)
    if (!sectionEl || !sectionId) return

    const pathname = window.location.pathname
    const { optionValueIds, requestUrl } = getCurrentSelectionFromVariantPicker(root, changedInput)

    if (optionValueIds.length === 0) return

    const request = new URL(requestUrl, window.location.origin)
    request.searchParams.set('section_id', sectionId)
    request.searchParams.set('option_values', optionValueIds.join(','))

    const nextPathname = new URL(request.toString()).pathname
    const shouldRetainElements = nextPathname === pathname

    if (activeController) {
      activeController.abort()
    }

    activeController = new AbortController()
    root.classList.add('combined-listing--loading')
    let qty = 1
    let qtyField = sectionEl.querySelector('.qty_pr_js')

    if (qtyField) {
      qty = qtyField.value
    }

    try {
      const response = await fetch(request.toString(), {
        signal: activeController.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })

      if (!response.ok) {
        throw new Error(`Combined listing render failed: ${response.status}`)
      }

      const nextHtml = await response.text()

      sectionEl.setAttribute('data-disable-transitions', 'true')
      if (!shouldRetainElements) {
        sectionEl.innerHTML = nextHtml
        const nextQtyField = sectionEl.querySelector('.qty_pr_js')
        if (nextQtyField) {
          if (nextQtyField.max) {
            if (+qty > +nextQtyField.max) {
              qty = nextQtyField.max
            }
          }
          nextQtyField.value = qty
        }
        initSection(sectionEl)
      } else {
        const nextDom = new DOMParser().parseFromString(nextHtml, 'text/html')
        const replaced = ['#shopify-section-pr_summary']
        replaced.forEach((selector) => {
          const el = sectionEl.querySelector(selector)
          const nextEl = nextDom.querySelector(selector)
          if (el && nextEl) {
            el.innerHTML = nextEl.innerHTML
          }
        })

        const nextQtyField = sectionEl.querySelector('.qty_pr_js')
        if (nextQtyField) {
          if (+qty > +nextQtyField.max) {
            qty = nextQtyField.max
          }
          nextQtyField.value = qty
        }

        runScripts(sectionEl)
        initLazyContent(sectionEl)
      }

      setTimeout(() => sectionEl.removeAttribute('data-disable-transitions'), 100)

      const nextUrl = buildPageUrl(sectionEl, optionValueIds)
      window.history.pushState({ path: nextUrl }, '', nextUrl)
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error(error)
      }
    } finally {
      const nextRoot = sectionEl.querySelector(ROOT_SELECTOR)
      ;(nextRoot || root).classList.remove('combined-listing--loading')
      activeController = null
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!event.isTrusted) return

      const item = event.target.closest('.swatch_pr_item[data-option-value-id]')
      if (!item) return

      const root = getRoot(item)
      if (!root) return

      event.preventDefault()
      event.stopImmediatePropagation()

      renderCombinedSection(root, item)
    },
    true,
  )

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest(
        'variant-selects input[data-option-value-id], variant-selects select.select__select',
      )
      if (!input) return

      const root = getRoot(input)
      if (!root) return

      renderCombinedSectionFromVariantPicker(root, input)
    },
    true,
  )
})()

const combinedCardMarkupCache = new Map()

class ProductCardSwatchScroll extends XThemeBaseElement {
  mount() {
    this._scrollEl = this.querySelector('[data-scrollable-target]')
    this._listEl = this._scrollEl?.querySelector('.swatches-on-grid') || null
    this._scrollThreshold = 14
    this._dragThreshold = 6
    this._dragState = null
    this._suppressClick = false

    if (!this._scrollEl || !this._listEl) return false

    this._mobileMedia = window.matchMedia('(max-width: 767px)')

    this._scrollEl.addEventListener('scroll', this._handleScroll, {
      passive: true,
      signal: this._ac.signal,
    })
    this._scrollEl.addEventListener('wheel', this._handleWheel, {
      passive: false,
      signal: this._ac.signal,
    })
    this._scrollEl.addEventListener('pointerdown', this._handlePointerDown, {
      passive: true,
      signal: this._ac.signal,
    })
    window.addEventListener('pointermove', this._handlePointerMove, {
      passive: false,
      signal: this._ac.signal,
    })
    window.addEventListener('pointerup', this._handlePointerUp, { signal: this._ac.signal })
    window.addEventListener('pointercancel', this._handlePointerUp, { signal: this._ac.signal })
    this.addEventListener('click', this._handleClick, { signal: this._ac.signal })
    this.addEventListener('click', this._handleSuppressedClick, {
      capture: true,
      signal: this._ac.signal,
    })
    window.addEventListener('resize', this._handleResize, { signal: this._ac.signal })

    if (typeof this._mobileMedia.addEventListener === 'function') {
      this._mobileMedia.addEventListener('change', this._handleResize, { signal: this._ac.signal })
    } else if (typeof this._mobileMedia.addListener === 'function') {
      this._mobileMedia.addListener(this._handleResize)
    }

    if (typeof ResizeObserver === 'function') {
      this._resizeObserver = new ResizeObserver(() => this._scheduleUpdate())
      this._resizeObserver.observe(this._scrollEl)
      this._resizeObserver.observe(this._listEl)
    }

    this._scheduleUpdate()
    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        if (this._connected) {
          this._scheduleUpdate()
        }
      })
    }
  }

  unmount() {
    cancelAnimationFrame(this._updateRaf)
    this._updateRaf = null
    this._dragState = null
    this._suppressClick = false
    this._scrollEl?.classList.remove('is-pointer-down', 'is-dragging')

    if (typeof this._mobileMedia?.removeEventListener === 'function') {
      this._mobileMedia.removeEventListener('change', this._handleResize)
    } else if (typeof this._mobileMedia?.removeListener === 'function') {
      this._mobileMedia.removeListener(this._handleResize)
    }

    this._resizeObserver?.disconnect()
    this._resizeObserver = null
  }

  _handleScroll = () => {
    this._update()
  }

  _handleWheel = (event) => {
    if (!this._isScrollActive()) return

    const maxScrollLeft = this._scrollEl.scrollWidth - this._scrollEl.clientWidth
    if (maxScrollLeft <= 2) return

    const horizontalDelta = Math.abs(event.deltaX)
    const shouldUseHorizontalWheel = event.shiftKey || horizontalDelta > 0

    if (!shouldUseHorizontalWheel) return

    const delta = horizontalDelta > 0 ? event.deltaX : event.deltaY
    if (!delta) return

    event.preventDefault()
    event.stopPropagation()
    this._scrollEl.scrollLeft += delta
  }

  _handlePointerDown = (event) => {
    if (!this._isScrollActive()) return
    if (event.pointerType !== 'mouse') return
    if (event.button !== 0) return
    if (event.target.closest('[data-scroll-direction]')) return

    this._dragState = {
      pointerId: event.pointerId,
      startX: event.clientX,
      startScrollLeft: this._scrollEl.scrollLeft,
      dragged: false,
    }
    this._suppressClick = false
    this._scrollEl.classList.add('is-pointer-down')
  }

  _handlePointerMove = (event) => {
    if (!this._dragState) return
    if (event.pointerId !== this._dragState.pointerId) return

    const deltaX = event.clientX - this._dragState.startX
    if (!this._dragState.dragged && Math.abs(deltaX) < this._dragThreshold) return

    this._dragState.dragged = true
    this._suppressClick = true
    this._scrollEl.classList.add('is-dragging')
    this._scrollEl.scrollLeft = this._dragState.startScrollLeft - deltaX
    event.preventDefault()
  }

  _handlePointerUp = (event) => {
    if (!this._dragState) return
    if (event.pointerId !== this._dragState.pointerId) return

    this._scrollEl.classList.remove('is-pointer-down', 'is-dragging')
    const didDrag = this._dragState.dragged
    this._dragState = null

    if (didDrag) {
      requestAnimationFrame(() => {
        this._suppressClick = false
      })
    } else {
      this._suppressClick = false
    }
  }

  _handleResize = () => {
    this._scheduleUpdate()
  }

  _handleClick = (event) => {
    const button = event.target.closest('[data-scroll-direction]')
    if (!button || !this.contains(button)) return

    event.preventDefault()
    event.stopPropagation()

    if (!this._isScrollActive()) return

    const direction = button.dataset.scrollDirection === 'prev' ? -1 : 1
    const distance = this._getScrollStep() * direction

    this._scrollEl.scrollBy({
      left: distance,
      behavior: 'smooth',
    })
  }

  _handleSuppressedClick = (event) => {
    if (!this._suppressClick) return
    if (event.target.closest('[data-scroll-direction]')) return

    event.preventDefault()
    event.stopPropagation()
  }

  _isScrollActive() {
    const mode = this.dataset.swatchScroll || 'mobile'

    if (mode === 'off') return false
    if (mode === 'always') return true

    return this._mobileMedia.matches
  }

  _getScrollStep() {
    const firstItem = this._listEl.querySelector('.nt-swatch-item')
    const listStyles = window.getComputedStyle(this._listEl)
    const gap = parseFloat(listStyles.columnGap || listStyles.gap || '0') || 0
    const itemWidth = firstItem?.getBoundingClientRect().width || 40
    const baseWidth = itemWidth + gap
    const usableViewportWidth = Math.max(this._scrollEl.clientWidth, itemWidth)
    const visibleItems = Math.max(1, Math.floor(usableViewportWidth / Math.max(baseWidth, 1)))

    return Math.max(baseWidth * Math.max(visibleItems - 1, 2), usableViewportWidth * 0.7)
  }

  _scheduleUpdate() {
    cancelAnimationFrame(this._updateRaf)
    this._updateRaf = requestAnimationFrame(() => {
      this._update()
      this._updateRaf = requestAnimationFrame(() => {
        this._update()
        this._updateRaf = requestAnimationFrame(() => {
          this._update()
        })
      })
    })
  }

  _update() {
    const isActive = this._isScrollActive()
    this.toggleAttribute('data-scroll-active', isActive)

    if (!isActive) {
      this.removeAttribute('data-can-scroll-left')
      this.removeAttribute('data-can-scroll-right')
      this.removeAttribute('data-has-scroll-overflow')
      return
    }

    const maxScrollLeft = Math.max(this._scrollEl.scrollWidth - this._scrollEl.clientWidth, 0)
    const hasOverflow = maxScrollLeft > 2
    const scrollLeft = this._scrollEl.scrollLeft
    const threshold = this._scrollThreshold

    this.toggleAttribute('data-has-scroll-overflow', hasOverflow)
    this.toggleAttribute('data-can-scroll-left', hasOverflow && scrollLeft > threshold)
    this.toggleAttribute(
      'data-can-scroll-right',
      hasOverflow && scrollLeft < maxScrollLeft - threshold,
    )
  }
}

const IS_NON_TOUCH_DEVICE = window.matchMedia('(hover: hover) and (pointer: fine)').matches

class ProductCardVariants extends XThemeBaseElement {
  async mount() {
    this._mounted = false
    this._combinedFetchController = null
    this._refreshElements()

    if (!this._parseCardData()) return false

    this._selectedOptions = this._getInitialSelectedOptions()
    if (!this._isCombinedProduct)  {
      this._sync()
    }

    this.addEventListener('click', this._handleClick, { signal: this._ac.signal })
    this.addEventListener('submit', this._handleSubmit, { signal: this._ac.signal })
    this.addEventListener('focusin', this._handleFocusIn, { signal: this._ac.signal })
    this.addEventListener('focusout', this._handleFocusOut, { signal: this._ac.signal })

    if (!this._hasHover && this._hasOverlayUi) {
      document.addEventListener('click', this._handleDocumentClick, {
        capture: true,
        signal: this._ac.signal,
      })
    }

    this._ac.signal.addEventListener(
      'abort',
      () => {
        this._abortCombinedFetch()
      },
      { once: true },
    )

    function fetchInitialHoverImageForCombinedProducts() {
      // const firstSwatch = this._buttons?.find((btn) => !!btn.getAttribute('data-product-url'))
      this._forceFetch = true
      const selectedSwatch = this.querySelector(
        '[data-product-card-option-button][aria-pressed="true"]',
      )
      if (selectedSwatch) {
        selectedSwatch.click()
      }
      requestAnimationFrame(() => {
        this._forceFetch = false
      })
    }

    fetchInitialHoverImageForCombinedProducts.call(this)
    this.addEventListener(
      'mouseenter',
      () => {
        fetchInitialHoverImageForCombinedProducts.call(this)
      },
      { signal: this._ac.signal, once: true },
    )

    const enterEvents = ['mouseenter', 'touchstart', 'focusin']
    const leaveEvents = ['mouseleave', 'touchend', 'blur']
    enterEvents.forEach((eventname) => {
      this.addEventListener(
        eventname,
        () => {
          this.setAttribute('data-in-focus', 'true')
        },
        { signal: this._ac.signal },
      )
    })

    leaveEvents.forEach((eventname) => {
      this.addEventListener(
        eventname,
        () => {
          this.setAttribute('data-in-focus', 'false')
        },
        { signal: this._ac.signal },
      )
    })

    this._productImagesContainer.addEventListener(
      'contextmenu', 
      (e) => {
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()
        return false
      }
    )

    this._mounted = true
  }

  unmount() {
    this._abortCombinedFetch()
    this._data = null
    this._selectedOptions = null
    this._currentVariant = null
    this._displayVariant = null
  }

  _refreshElements() {
    this._buttons = Array.from(this.querySelectorAll('[data-product-card-option-button]'))
    this._variantInput = this.querySelector('input[name="id"].product-variant-id')
    this._form = this._variantInput?.form || null
    this._submitButton = this.querySelector('.js-atc-button')
    this._buttonLabel = this._submitButton?.querySelector('span') || this._submitButton
    this._priceEl = this.querySelector('[data-product-card-price]')
    this._imageEl = this.querySelector('[data-product-card-main-image]')
    this._imageHoverEl = this.querySelector('[data-product-card-hover-image]')
    this._links = Array.from(this.querySelectorAll('[data-product-card-link]'))
    this._subtitleEl = this.querySelector('[data-product-card-subtitle]')
    this._jsonEl =
      this.querySelector('[data-product-card-json]') || this.querySelector('.pr-variant-data')
    this._overlay = this.querySelector('[data-product-card-overlay]')
    this._optionCount = Number(this.dataset.optionCount || 0)
    this._hasHover = IS_NON_TOUCH_DEVICE
    this._hasOverlayUi = Boolean(this._overlay?.children.length)
    this._quickShopTriggerBtn = this.querySelector('[data-quick-shop-trigger]')
    this._productImagesContainer = this.querySelector('[data-product-images-container]')
  }

  _isCombinedProduct() {
    return this.getAttribute('data-is-combined-product') === 'true'
  }

  _parseCardData() {
    if (!this._jsonEl) return false

    try {
      this._data = JSON.parse(this._jsonEl.textContent)
    } catch (error) {
      console.error('Unable to parse product card variant data', error)
      return false
    }

    return Boolean(this._data?.variants?.length)
  }

  _handleClick = async (event) => {
    const target = event.target

    if (target instanceof HTMLAnchorElement) {
      return
    }

    if (this._quickShopTriggerBtn) {
      if (target == this._quickShopTriggerBtn) {
        this.setAttribute('data-overlay-options-visible', 'true')
        this.addEventListener(
          'mouseleave',
          (event) => {
            this.setAttribute('data-overlay-options-visible', 'false')
          },
          { once: true, signal: this._ac.signal },
        )
        return
      }
    }

    const button = target.closest('[data-product-card-option-button]')
    const link = target.closest('[data-product-card-link]')

    if (!button || !this.contains(button)) {
      if (
        !this._hasHover &&
        this._hasOverlayUi &&
        link &&
        this.contains(link) &&
        !this.classList.contains('is-overlay-active')
      ) {
        event.preventDefault()
        this._showOverlay()
      }
      return
    }

    event.preventDefault()
    this._showOverlay()

    const optionIndex = Number(button.dataset.optionPosition || 0) - 1
    if (optionIndex < 0) return

    const optionTerminal = button.dataset.optionTerminal === 'true'

    this._clickedSwatchBtn = button
    this._clickedSwatchIndex = optionIndex
    this._clickedTerminal = optionTerminal

    if (!this._selectedOptions) {
      this._selectedOptions = this._getInitialSelectedOptions()
    }

    this._selectedOptions[optionIndex] = this._normalizeValue(button.dataset.optionValue)
    this._currentVariant = this._findVariant(this._selectedOptions, true)

    let nextProductUrl = button.dataset.productUrl
    if (!nextProductUrl) {
      const buttons = this._selectedOptions.map((value, i) => this.querySelector(`button[data-option-position="${i + 1}"][data-option-value="${value}"]`))
      for (const btn of buttons) {
        nextProductUrl = btn.getAttribute('data-product-url') || ''
        if (nextProductUrl) break
      }
    }

    if (event.isTrusted) {
      // debugger
    }

    const combinedSync = this._shouldFetchCombinedProduct(nextProductUrl)
    if (combinedSync && combinedSync.can) {
      if (combinedSync.should) {
        await this._syncCombinedProduct(nextProductUrl, [...this._selectedOptions], optionIndex)
      }
    } else {
      this._sync(optionIndex, { viaFetch: this._forceFetch || false, variant: optionTerminal ? this._currentVariant : undefined })
    }

    // this is also triggered on initial page load via `fetchInitialHoverImageForCombinedProducts`
    // so as soon as page loads, it triggers this fn and also add-to-cart
    // we need to ensure add-to-cart is only triggered via user interaction
    if (event.isTrusted) {
      if (optionTerminal && this._currentVariant?.available) {
        this._submitCurrentVariant()
      }
    }
  }

  _handleSubmit = (event) => {
    if (!this.contains(event.target)) return

    if (!this._currentVariant || !this._currentVariant.available) {
      event.preventDefault()
      return
    }

    if (window.addItemFrom) {
      event.preventDefault()
      this._addToCart().then(() => {
        this.setAttribute('data-overlay-options-visible', 'false')
      })
      return
    }
  }

  _handleFocusIn = () => {
    this._showOverlay()
  }

  _handleFocusOut = () => {
    requestAnimationFrame(() => {
      if (!this.contains(document.activeElement)) {
        this._hideOverlay()
      }
    })
  }

  _handleDocumentClick = (event) => {
    if (this.contains(event.target)) return
    this._hideOverlay()
  }

  _normalizeValue(value) {
    return value == null ? '' : `${value}`
  }

  _normalizeProductKey(value) {
    if (!value) return ''

    try {
      const url = new URL(value, window.location.origin)
      const pathname = url.pathname.replace(/\/+$/, '')
      return pathname || '/'
    } catch (error) {
      return `${value}`.replace(/\/+$/, '') || '/'
    }
  }

  _buildCardSyncUrl(productUrl) {
    const requestUrl = new URL(productUrl, window.location.origin)
    requestUrl.searchParams.delete('section_id')
    requestUrl.searchParams.delete('option_values')
    requestUrl.searchParams.set('view', 'card-sync')

    let optionValueIds = [1, 2, 3].reduce((acc, optionPosition) => {
      
      let optionBtn = optionPosition === this._clickedSwatchIndex + 1 ? this._clickedSwatchBtn : this.querySelector(`[data-option-value-id][data-option-position="${optionPosition}"][aria-pressed="true"]`) || this.querySelector(`[data-option-value-id][data-option-position="${optionPosition}"]:not(.is-soldout)`) || this.querySelector(`[data-option-value-id][data-option-position="${optionPosition}"]`)

      const optionValueId = optionBtn?.dataset.optionValueId
      if (optionValueId) {
        acc.push(optionValueId)
      }
      return acc
    }, [])
    
    // get all the selected options and extract their option value ids
    if (optionValueIds) {
      requestUrl.searchParams.set('option_values', optionValueIds.join(','))
    }

    return requestUrl
  }

  _shouldFetchCombinedProduct(productUrl) {
    if (!this._isCombinedProduct) return false
    if (!productUrl) return false

    const currentProductKey = this._normalizeProductKey(
      this.dataset.productSourceUrl || this._data?.productUrl || '',
    )
    const nextProductKey = this._normalizeProductKey(productUrl)

    const can = !!nextProductKey && !!currentProductKey
    const should = can && nextProductKey !== currentProductKey
    // return Boolean(nextProductKey && currentProductKey && nextProductKey !== currentProductKey)
    return { can, should }
  }

  _abortCombinedFetch() {
    if (this._combinedFetchController) {
      this._combinedFetchController.abort()
      this._combinedFetchController = null
    }
  }

  async _fetchCombinedProductMarkup(productUrl, signal) {
    const cacheKey = this._normalizeProductKey(productUrl)
    if (cacheKey && combinedCardMarkupCache.has(cacheKey)) {
      return combinedCardMarkupCache.get(cacheKey)
    }
    this.setAttribute('data-fetching', 'true')
    const response = await fetch(this._buildCardSyncUrl(productUrl).toString(), {
      signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
    this.setAttribute('data-fetching', 'false')

    if (!response.ok) {
      throw new Error(`Product card sync failed: ${response.status}`)
    }

    const html = await response.text()
    if (cacheKey) {
      combinedCardMarkupCache.set(cacheKey, html)
    }

    return html
  }

  _extractFetchedCard(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html')
    return (
      parsed.querySelector('[data-product-card-sync-response] [data-product-card]') ||
      parsed.querySelector('[data-product-card]')
    )
  }

  _replaceCardRegion(selector, fetchedCard) {
    const currentRegion = this.querySelector(selector)
    const nextRegion = fetchedCard.querySelector(selector)

    if (currentRegion && nextRegion) {
      currentRegion.replaceWith(nextRegion.cloneNode(true))
    }
  }

  _replaceFetchedCardRegions(fetchedCard) {
    ;[
      '[data-product-card-hover-region]',
      '[data-product-card-primary-options]',
      '[data-product-card-overlay-region]',
      '[data-product-card-atc]',
      '[data-product-card-json]',
      '[data-product-card-subtitle]',
    ].forEach((selector) => {
      this._replaceCardRegion(selector, fetchedCard)
    })
    ;[
      'data-product-id',
      'data-option-count',
      'data-product-source-url',
      'data-product-source-handle',
      'data-selected-variant-id',
      'data-subtitle-option-index',
      'data-available',
    ].forEach((attributeName) => {
      if (fetchedCard.hasAttribute(attributeName)) {
        this.setAttribute(attributeName, fetchedCard.getAttribute(attributeName))
      } else {
        this.removeAttribute(attributeName)
      }
    })
  }

  _optionValueExistsAt(index, value) {
    if (!value) return false

    return this._data?.variants?.some(
      (variant) => this._normalizeValue(variant.options[index]) === this._normalizeValue(value),
    )
  }

  _reconcileSelections(previousSelections = []) {
    const fallbackSelections = this._getInitialSelectedOptions()
    const nextSelections = [...fallbackSelections]

    nextSelections.forEach((fallbackValue, index) => {
      const previousValue = previousSelections[index]
      if (this._optionValueExistsAt(index, previousValue)) {
        nextSelections[index] = this._normalizeValue(previousValue)
        return
      }

      nextSelections[index] = this._normalizeValue(fallbackValue)
    })

    return nextSelections
  }

  async _syncCombinedProduct(productUrl, preservedSelections, changedIndex = -1) {
    this._abortCombinedFetch()

    const controller = new AbortController()
    this._combinedFetchController = controller

    try {
      const html = await this._fetchCombinedProductMarkup(productUrl, controller.signal, changedIndex)
      if (controller.signal.aborted || !this._connected) return false

      const fetchedCard = this._extractFetchedCard(html)
      if (!fetchedCard) return false

      this._replaceFetchedCardRegions(fetchedCard)
      this._refreshElements()

      if (!this._parseCardData()) {
        return false
      }

      this._selectedOptions = this._reconcileSelections(preservedSelections)
      this._sync(changedIndex, { viaFetch: true })
      return true
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error(error)
      }

      return false
    } finally {
      if (this._combinedFetchController === controller) {
        this._combinedFetchController = null
      }
    }
  }

  _getVariantById(variantId) {
    return this._data?.variants?.find((variant) => `${variant.id}` === `${variantId}`) || null
  }

  _findVariant(selectedOptions, exact = false) {
    const allVariants = this._data?.variants
    if (!allVariants || !allVariants.length) return null

    if (exact) {
      const matching = allVariants.find((variant) =>
        variant.options.every((optionValue, index) => {
          return this._normalizeValue(optionValue) === this._normalizeValue(selectedOptions[index])
        })
      )

      return matching
    }

    const optionsCount = this._optionCount

    const matchingVariants =
      allVariants.filter((variant) =>
        variant.options.every((optionValue, index) => {
          const isLast = index === optionsCount - 1
          if (isLast && optionsCount > 1) return true
          return this._normalizeValue(optionValue) === this._normalizeValue(selectedOptions[index])
        }),
      ) || null

    let firstAvailable = matchingVariants?.find((variant) => variant.available) || null

    // @TODO: Task for codex
    if (!firstAvailable && optionsCount > 1) {
      // reset the >1 selected options - starting from last
      // example: ['Green', 'XS'] is passed in as selected options - changed from Red-XS to Green-XS
      // Green-XS is soldout, we now we need to check if any Green-{size} variant is available
      // if so, use that. And change the selected options to Green-{size}
      // also ensure it works for 3 options [size, color, material] etc. in similar fashion
      // example: ['Green', 'Leather', 'XS'] is passed in as selected options - changed from Red-Leather-XS to Green-Leather-XS
      // we try to find a Green-Leather-{size} variant that is available
      // if not, we try to find a Green-{material}-{size} variant that is available etc
      // if not, we just return the matching color (first option) variant that is available or soldout
      for (let prefixLength = optionsCount - 1; prefixLength >= 1; prefixLength -= 1) {
        const prefixMatches = allVariants.filter((variant) =>
          variant.options.every((optionValue, index) => {
            if (index >= prefixLength) return true
            return (
              this._normalizeValue(optionValue) === this._normalizeValue(selectedOptions[index])
            )
          }),
        )

        const nextVariant =
          prefixMatches.find((variant) => variant.available) ||
          (prefixLength === 1 ? prefixMatches[0] || null : null)

        if (!nextVariant) continue

        firstAvailable = nextVariant
        selectedOptions.splice(
          0,
          selectedOptions.length,
          ...nextVariant.options.map((optionValue) => this._normalizeValue(optionValue)),
        )
        break
      }
    }

    return firstAvailable || matchingVariants?.[0] || null
  }

  _getInitialSelectedOptions() {
    const selectedId = this._variantInput?.value || this._data?.selectedVariantId
    const initialVariant =
      this._getVariantById(selectedId) ||
      this._data?.variants?.find((variant) => variant.available) ||
      this._data?.variants?.[0] ||
      null

    return initialVariant?.options?.map((optionValue) => this._normalizeValue(optionValue)) || []
  }

  _getCandidateScore(variant, changedIndex) {
    let score = variant.available ? 1000 : 0

    variant.options.forEach((optionValue, index) => {
      if (
        this._normalizeValue(optionValue) !== this._normalizeValue(this._selectedOptions[index])
      ) {
        return
      }

      score += index === changedIndex ? 100 : 10
    })

    return score
  }

  _getDisplayVariant(changedIndex = -1) {
    if (!this._data?.variants?.length) return null

    if (this._currentVariant) {
      return this._currentVariant
    }

    const candidates = this._data.variants
      .filter((variant) => {
        if (changedIndex < 0) return true

        return (
          this._normalizeValue(variant.options[changedIndex]) ===
          this._normalizeValue(this._selectedOptions[changedIndex])
        )
      })
      .sort(
        (variantA, variantB) =>
          this._getCandidateScore(variantB, changedIndex) -
          this._getCandidateScore(variantA, changedIndex),
      )

    return candidates[0] || this._displayVariant || this._data.variants[0]
  }

  _updateCardImage(variant) {
    // tuple shape: [image element, image object]
    // for main and hover image
    const images = variant?.images
    const mounted = this._mounted

    const data = [
      [this._imageEl, images?.[0]],
      [this._imageHoverEl, images?.[1]],
    ]
    for (let i = 0, l = data.length; i < l; i++) {
      const [el, image] = data[i]
      if (!el || !image?.src) continue

      if (image.id) {
        el.dataset.id = image.id
      }

      el.style.backgroundImage = `url("${image.src}")`
      el.classList.add('lazyloaded')

      if (image.aspectRatio) {
        el.style.paddingTop = `${100 / image.aspectRatio}%`
      }

      if (i > 0 && mounted) {
        // preload image
        const img = new Image()
        img.src = image.src
      }
    }
  }

  _updateCardSwatchImages(variant) {
    // update color swatch images if swatch hex is missing
    const missingEls = this.querySelectorAll('[data-swatch-variant-image-placeholder]')
    for (let i = 0, l = missingEls.length; i < l; i++) {
      const missingEl = missingEls[i]
      const btn = missingEl.closest('button')
      const optionIndex = +btn.getAttribute('data-option-position') - 1
      const optionName = btn.getAttribute('data-option-name')
      const optionValue = btn.getAttribute('data-option-value')
      const matchingVariant = this._data.variants.find(
        (v) => v.options[optionIndex] === optionValue && v.has_featured_image,
      )
      const src =
        matchingVariant?.images?.[0]?.src ||
        '//cdn.shopify.com/s/files/1/2388/0287/files/placeholder-6.png?v=1776077548&width=100&height=100'
      if (matchingVariant || src) {
        missingEl.style.backgroundImage = `url('https:${src}')`
      }
    }
  }

  _updateCardTitles(variant) {
    const subtitleIndex = +this.getAttribute('data-subtitle-option-index') || 0
    if (subtitleIndex < 0) return
    const value = variant?.options[subtitleIndex]
    if (!value) return
    const element = this.querySelector('[data-product-card-subtitle]')
    if (!element) return
    element.textContent = value
  }

  _updateCardLinks(variant) {
    if (!variant) return

    const nextUrl = variant.url || `${this._data.productUrl}?variant=${variant.id}`
    this._links.forEach((link) => {
      link.href = nextUrl
    })
  }

  _updateCardPrice(variant) {
    if (this._priceEl && variant?.priceHtml) {
      this._priceEl.innerHTML = variant.priceHtml
    }
  }

  _updateAddToCartState() {
    if (this._variantInput) {
      this._variantInput.value = this._currentVariant?.id || ''
    }

    if (!this._submitButton || !this._buttonLabel) return

    const addToCartLabel = this._submitButton.dataset.addToCartLabel || 'Add to Cart'
    const soldOutLabel = this._submitButton.dataset.soldOutLabel || 'Sold Out'
    const isPurchasable = Boolean(this._currentVariant?.available)

    this._submitButton.disabled = !isPurchasable
    this._submitButton.classList.toggle('is-disabled', !isPurchasable)
    this._buttonLabel.textContent = isPurchasable ? addToCartLabel : soldOutLabel
  }

  _updateOptionStates() {
    const optionCount = +this.getAttribute('data-option-count') || 0

    this._buttons.forEach((button) => {
      const optionIndex = Number(button.dataset.optionPosition || 0) - 1
      const optionValue = this._normalizeValue(button.dataset.optionValue)

      const matchingVariants = this._data.variants.filter((variant) => {
        if (this._normalizeValue(variant.options[optionIndex]) !== optionValue) {
          return false
        }
        // only match up until optionIndex - rest are considered matched
        return variant.options.every(
          (value, index) =>
            index >= optionIndex ||
            this._normalizeValue(value) === this._normalizeValue(this._selectedOptions[index]),
        )

        // return variant.options.every((value, index) => {
        //   if (index === optionIndex) return true
        //   return this._normalizeValue(value) === this._normalizeValue(this._selectedOptions[index])
        // })
      })

      const isSelected = this._normalizeValue(this._selectedOptions[optionIndex]) === optionValue
      const hasMatchingVariant = matchingVariants.length > 0
      const hasAvailableVariant = matchingVariants.some((variant) => variant.available)

      // if there are > 1 options, then we won't apply selected state to the LAST option button
      // because that acts as the "add to cart" button
      const isLast = optionIndex === optionCount - 1
      const onlyOption = optionCount === 1
      let pressed = isSelected
      if (isLast && !onlyOption) {
        pressed = false
      }

      const soldout = !hasMatchingVariant || !hasAvailableVariant
      const disabled = !hasMatchingVariant && !isSelected

      button.setAttribute('aria-pressed', pressed ? 'true' : 'false')
      // button.disabled = !hasMatchingVariant && !isSelected
      button.classList.toggle('is-disabled', !hasMatchingVariant)
      button.classList.toggle('is-soldout', soldout)
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false')
    })
  }

  _showOverlay() {
    if (this._hasOverlayUi) {
      // this.classList.add('is-overlay-active')
    }
  }

  _hideOverlay() {
    if (this._hasOverlayUi) {
      this.classList.remove('is-overlay-active')
    }
  }

  _submitCurrentVariant() {
    //  debugger

    if (!this._form || !this._currentVariant?.available) return

    if (window.addItemFrom) {
      this._addToCart().then(() => {
        this.setAttribute('data-overlay-options-visible', 'false')
      })
      return
    }

    if (typeof this._form.requestSubmit === 'function') {
      this._form.requestSubmit()
      return
    }
    this._form.submit()
  }

  _sync(changedIndex = -1, { viaFetch = false, variant } = {}) {
    this._currentVariant = variant || this._findVariant(this._selectedOptions)

    if (this._currentVariant?.options) {
      for (let i = 0, l = this._currentVariant.options.length; i < l; i++) {
        this._selectedOptions[i] = this._currentVariant.options[i]
      }
    }

    this._displayVariant = this._getDisplayVariant(changedIndex)

    if (this._currentVariant) {
      this.dataset.selectedVariantId = this._currentVariant.id
    } else {
      delete this.dataset.selectedVariantId
    }

    const available = this._currentVariant?.available
    if (typeof available === 'boolean') {
      this.setAttribute('data-available', available ? 'true' : 'false')
    }

    this._updateCardLinks(this._displayVariant)
    this._updateCardTitles(this._displayVariant)
    this._updateCardImage(this._displayVariant)
    this._updateCardSwatchImages(this._displayVariant)
    this._updateCardPrice(this._displayVariant)
    this._updateAddToCartState()
    if (!viaFetch) {
      this._updateOptionStates()
    }
  }

  async _addToCart() {
    const variantId = this._currentVariant?.id
    if (!variantId) return
    let root = window.Shopify?.routes?.root || '/'
    if (root.endsWith('/')) root = root.slice(0, -1)
    const endpoint = window.t_cartadd_url ? t_cartadd_url + '.js' : `${root}/cart/add.js`

    this.setAttribute('data-adding-to-cart', 'true')

    const result = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart_js',
      }),
    })
      .then((r) => r.json())
      .then((line_item) => {
        if (line_item.status && line_item.status !== 200) {
          let error = new Error(line_item.description)
          error.isFromServer = true
          throw error
        }

        const addedProductId = +(line_item.items?.[0]?.product_id || 19041994)
        if (!addedProductId) {
          let error = new Error(`Unable to add product to cart`)
          error.isFromServer = true
          throw error
        }

        //console.log(line_item)
        geckoShopify.onCartUpdate(1, 1, line_item.sections.cart_js, addedProductId)
        window.miniCartUpsell?.(addedProductId)

        if (addedProductId != 19041994) {
          let stockEl = $('.nt_stock_page[data-prid="' + addedProductId + '"]')
          if (stockEl?.length) {
            let totalQty = line_item.quantity
            geckoShopify.progressbarUpdateATC(el, totalQty)
          }
        }

        $('body').trigger('CartUpdateSuccess')

        return line_item
      })
      .finally(() => {
        this.removeAttribute('data-adding-to-cart')
      })

    return result
  }
}

if (!window.customElements.get('x-product-card')) {
  window.customElements.define('x-product-card', ProductCardVariants)
}

if (!window.customElements.get('x-product-card-swatch-scroll')) {
  window.customElements.define('x-product-card-swatch-scroll', ProductCardSwatchScroll)
}
